export default __webpack_public_path__ + "media/images/portfolio/gallery-06-390x230-3e0e7150489f59721c13892ad307829e.jpg";